export class PublicKeyDto {
  constructor() {
    this.kid = void 0;
    this.kty = void 0;
    this.e = void 0;
    this.n = void 0;
    this.use = void 0;
  }

}